import Cookies from "universal-cookie";

export const COOKIE_NAME = `websiteId`;

export default new Cookies();
